export const nonAdminNotificationLink = (type, id) => {
  if (type === 'ACCEPTED_DOCUMENT' || type === 'REJECTED_DOCUMENT') {
    return `/documents/${id}`;
  }

  if (
    type === 'ACCEPTED_QUESTIONNAIRE' ||
    type === 'REJECTED_QUESTIONNAIRE' ||
    type === 'REJECTED_QUESTION'
  ) {
    return `/questionnaire/${id}`;
  }

  if (type === 'UPDATED_PRODUCT_STATUS') {
    return `/product/${id}`;
  }
};

export const notificationLinkText = (type) => {
  if (type === 'ACCEPTED_DOCUMENT' || type === 'REJECTED_DOCUMENT') {
    return 'Document link';
  }

  if (
    type === 'ACCEPTED_QUESTIONNAIRE' ||
    type === 'REJECTED_QUESTIONNAIRE' ||
    type === 'REJECTED_QUESTION'
  ) {
    return 'Questionnaire link';
  }

  if (type === 'UPDATED_PRODUCT_STATUS') {
    return 'Product link';
  }
};
